import {
  base_colorContentBorder,
  base_colorContentBorderSecondary,
  base_colorSurface,
  cta_linkTextPrimary,
  cta_linkTextPrimaryHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  position: fixed;
  bottom: ${spacing(8)};
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  align-items: stretch;
  background-color: ${base_colorSurface};
  border: 1px solid ${base_colorContentBorder};
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;
`

export const count = css`
  display: inline-flex;
  align-items: center;
  padding: ${spacing(3)} ${spacing(5)};
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
  white-space: nowrap;
`

export const divider = css`
  align-self: stretch;
  width: 1px;
  /*
    Lighter semantic sibling of base_colorContentBorder. The container's
    primary border uses base_colorContentBorder; using the secondary token
    here keeps internal separators visibly subordinate to the outer edge
    while still respecting white-label theming.
  */
  background-color: ${base_colorContentBorderSecondary};
`

export const assignButton = css`
  display: inline-flex;
  align-items: center;
  padding: ${spacing(3)} ${spacing(5)};
  background: transparent;
  border: none;
  cursor: pointer;
  ${font_md};
  font-family: ${font_family_weight_medium};
  color: ${cta_linkTextPrimary};
  white-space: nowrap;

  &:hover {
    color: ${cta_linkTextPrimaryHover};
  }

  &:focus-visible {
    outline: 2px solid ${cta_linkTextPrimary};
    outline-offset: -4px;
  }
`

export const closeButton = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${spacing(9)};
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${text_colorTextPrimary};

  &:hover {
    color: ${text_colorTextSecondary};
  }

  &:focus-visible {
    outline: 2px solid ${cta_linkTextPrimary};
    outline-offset: -4px;
  }
`
